import {
  Fragment,
  useContext,
  useEffect,
} from "react";
import { AuthContext } from "../../store/auth-context";
//* import global component

import FormControl from "../UI/FormControl";
//* import styles
import styles from "./SignUpForm.module.css";
//TODO this contains just two form controls
const SignUpForm2 = (props) => {
  const emailCtx = useContext(AuthContext);
  const { formState, onDispatchForm } = props;

  const { emailIsValid, error } = formState;
  const changeEmailAddressHandler = (event) => {
    const value = event.target.value;
    onDispatchForm({
      type: "EMAIL_INPUT",
      value,
    });
  };
  useEffect(() => {
    onDispatchForm({
      type: "EMAIL_EXIST",
      value: emailCtx.emailExist.email,
      emailExistError: emailCtx.emailExist.error,
    });
  }, [emailCtx.emailExist, onDispatchForm]);
  useEffect(() => {
    onDispatchForm({
      type: "EMAIL_EXIST_RESET",
    });
  }, [emailCtx.toSignUp, onDispatchForm]);
  return (
    <Fragment>
      <div className={styles["form-controls"]}>
        <FormControl
          error={error.emailError}
          errorClassName={styles["error"]}
          Input={{
            type: "email",
            id: "email",
            value: formState.emailValue,
            onChange: changeEmailAddressHandler,
            // onBlur: blurInputHandler,
          }}
          Label={{
            child: { label: "Email Address" },
            properties: {
              htmlFor: "email",
            },
          }}
          className={`${styles["form-control"]}
            ${
              emailIsValid
                ? ""
                : styles["invalid"]
            }`}
        />
      </div>
    </Fragment>
  );
};

export default SignUpForm2;
